import React, { useContext, useState } from "react";
import "./Feedback.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Successfull_strip_modal from "../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { SubmitFeedback } from "../../features/auth/Slice";
import { Context } from "../../utils/context";
import { useNavigate } from "react-router-dom";

function Feedback() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");


  const { signin } = useContext(Context)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: { feedback: "" },
  });

  const onSubmit = async (data) => {
    try {
      if (!signin) {

        setModalMessage("Please Login To send Feedback!");
        setModalShow(true);
        setTimeout(() => {
          navigate("/");
          setModalShow(false)
        }, 3000);

      }
      const formData = new FormData();
      formData.append("description", data?.feedback);

      const res = await dispatch(SubmitFeedback(formData));

      if (res.meta?.requestStatus === "fulfilled") {
        reset();
        setModalMessage(res?.payload?.data || "Feedback submitted successfully!");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      } else {
        setModalMessage(res?.payload?.errors || "Submission failed. Try again.");
        setModalShow(true);
        setTimeout(() => setModalShow(false), 3000);
      }
    } catch (error) {
      console.error("Feedback error:", error);
    }
  };

  return (
    <>
      <section className="Feedback">
        <Common_white_header headingText={"Feedback"} />
        <div className="container">
          <Form onSubmit={handleSubmit(onSubmit)} noValidate>

            <div className="form-group field_holder">
              <Form.Group className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Welcome to feedback, please give feedback-please describe the problem in detail when providing feedback, preferably attach a screenshot of the problem you encountered, we will immediately process your feedback!"
                  {...register("feedback", {
                    required: "Please enter your feedback",
                    minLength: {
                      value: 10,
                      message: "Feedback must be at least 10 characters",
                    },
                    maxLength: {
                      value: 500,
                      message: "Feedback cannot exceed 500 characters",
                    },
                  })}
                />
                {errors.feedback && (
                  <small className="text-danger d-block mt-1">
                    {errors.feedback.message}
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="note_text_Holder">
              <p>Send Helpful Feedback Chance To Win Mystery Rewards</p>
              <div className="img_holder">
                <img
                  className="sticker_img"
                  src="/assets/images/Feedback/Feedback_sticker.png"
                  alt="sticker"
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn_register_bg my-5"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>

          </Form>
        </div>
      </section>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </>
  );
}

export default Feedback;